
import utils from '@/utils';
import { defineComponent } from 'vue';
import { INode } from '@/types/models';
import api, { IShellResult } from '@/api/admin/nodes';
import { IElForm } from '@/types/element';

interface IAssistantForm {
  command: string;
  results: string;
}

interface IUpdateImageForm {
  nodeId: number;
  version: string;
}

interface IState {
  items: INode[];
  node: INode;
  isFormAdd: boolean;
  shellResult: IShellResult;
  isShell: boolean;
  isAssistant: boolean;
  assistantForm: IAssistantForm;
  isUpdateImage: boolean;
  updateImageForm: IUpdateImageForm;
}

export default defineComponent({
  data() {
    return {
      items: [],
      node: {
        id: 0,
        isReserves: false,
        nodeName: '',
        ipAddress: '',
      } as INode,
      isFormAdd: false,
      shellResult: {
        nginx: '',
      } as IShellResult,
      isShell: false,
      isAssistant: false,
      assistantForm: {} as IAssistantForm,
      isUpdateImage: false,
      updateImageForm: {} as IUpdateImageForm,
    } as IState;
  },
  methods: {
    apiGet() {
      api.get((res) => {
        this.items = res.items;
      });
    },

    btnShellClick(node: INode) {
      api.shell(node.id, (res) => {
        if (!res) return;
        this.isShell = true;
        this.shellResult = res;
      });
    },

    btnCertClick(node: INode) {
      utils.alertDelete(
        {
          title: '更新节点HTTPS证书',
          text: `此操作将更新 ${node.nodeName} 的节点HTTPS证书，确定吗？`,
          button: '确认更新',
        },
        () => {
          api.updateCert(node.id, (res) => {
            if (!res) return;
            utils.success('节点HTTPS证书更新成功！');
            this.apiGet();
          });
        },
      );
    },

    btnAssistantClick(node: INode) {
      this.node = { ...node };
      this.isAssistant = true;
      this.assistantForm = {
        command: '',
        results: '',
      };
    },

    btnAssistantSubmitClick() {
      this.assistantForm.results = '';
      api.assistant(
        {
          nodeId: this.node.id,
          command: this.assistantForm.command,
        },
        (res) => {
          if (!res) return;
          this.assistantForm.results = res.value;
        },
      );
    },

    btnDeleteClick(node: INode) {
      utils.alertDelete(
        {
          title: '删除服务器',
          text: `此操作将删除服务器${node.nodeName}，确定吗？`,
          button: '确认删除',
        },
        () => {
          api.delete(node.id, (res) => {
            if (!res) return;
            this.apiGet();
            utils.success('服务器删除成功');
          });
        },
      );
    },

    btnRebootClick(node: INode) {
      utils.alertDelete(
        {
          title: '重启服务器',
          text: `此操作将重启服务器${node.nodeName}，确定吗？`,
          button: '确认重启',
        },
        () => {
          api.reboot(node.id, (res) => {
            if (!res) return;
            utils.success('服务器重启成功');
          });
        },
      );
    },

    btnReloadClick(node: INode) {
      utils.alertDelete(
        {
          title: '重启所有实例',
          text: `此操作将重启${node.nodeName}的所有实例，确定吗？`,
          button: '确认重启',
        },
        () => {
          api.reload(node.id, (res) => {
            if (!res) return;
            utils.success('所有实例重启成功');
          });
        },
      );
    },

    formReset() {
      const form = this.$refs.form as IElForm;
      form.clearValidate();
    },

    btnAddClick() {
      this.node = {
        id: 0,
        isReserves: false,
        isHongKong: false,
        isEnabled: false,
        nodeName: '',
        ipAddress: '',
        instanceId: '',
        regionId: 'cn-beijing',
      } as INode;
      this.isFormAdd = true;
    },

    btnEditClick(node: INode) {
      this.node = { ...node };
      this.isFormAdd = true;
    },

    btnSubmitClick() {
      (this.$refs.form as IElForm).validate((valid) => {
        if (valid) {
          api.submit(this.node, (res) => {
            if (!res) return;
            this.isFormAdd = false;
            this.apiGet();
            utils.success(`服务器${this.node.id === 0 ? '添加' : '修改'}成功`);
          });
        }
      });
    },

    btnUpdateImageClick(node: INode) {
      this.updateImageForm.nodeId = node.id;
      this.updateImageForm.version = '';
      this.isUpdateImage = true;
    },

    btnUpdateImageSubmitClick() {
      (this.$refs.updateImageForm as IElForm).validate((valid) => {
        if (valid) {
          api.updateImage(this.updateImageForm, (res) => {
            if (!res) return;
            this.isUpdateImage = false;
            this.apiGet();
            utils.success('Docker Image 更新成功');
          });
        }
      });
    },
  },
  mounted() {
    this.apiGet();
  },
});
